import { render, staticRenderFns } from "./project-tab-equipment.vue?vue&type=template&id=e0f70b96&scoped=true"
import script from "./project-tab-equipment.vue?vue&type=script&lang=ts"
export * from "./project-tab-equipment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f70b96",
  null
  
)

export default component.exports